import React from "react";
import { Position, OverlayToaster as BlueprintToaster } from "@blueprintjs/core";
import ErrorIcon from "icons/error.svg";
import InfoIcon from "icons/toast-info.svg";
import * as styles from "./styles.module.scss";
export const toastIcons = {
    error: React.createElement(ErrorIcon, { className: styles.icon }),
    info: React.createElement(InfoIcon, { className: styles.icon }),
};
const toaster = await BlueprintToaster.createAsync({
    position: Position.TOP_RIGHT,
});
const Toaster = () => toaster;
export default Toaster;
